<template>
  <div class="page-menu">
    <div class="responsive"></div>

    <!-- btn close on small devices -->
    <span class="btn-menu-close" uk-toggle="target: #wrapper ; cls: mobile-active"></span>
    <!-- traiger btn -->
    <span class="btn-menu-trigger" uk-toggle="target: .page-menu ; cls: menu-large"></span>
    <!-- logo -->
    <div class="logo uk-visible@s" style="justify-content: center">
      <router-link to="/admin/dashboard">
        <img style="width: 100%" alt="" :src="logo" />
      </router-link>
    </div>
    <div class="page-menu-inner" data-simplebar>
      <form class="menu-search uk-search">
        <label for="menusearch" style="position: absolute; top: 17px; left: 45px"><i class="uil-search-alt"></i></label>
        <input id="menusearch" class="uk-search-input" v-model="searchForMenu" autocomplete="off"
          :placeholder="$t('general.search_in_menu')" style="height: 38px; border-radius: 5px; padding-left: 40px"
          type="search" />
      </form>
      <ul class="mt-0 pb-5 sideNavMenu" id="admin_sideNavMenu">
        <li>
          <router-link :to="{ name: 'company.dashboard' }">
            <i class="uil-home-alt"></i>
            <span class="sideNavMenu_item_title">
              {{ $t("sideNav.Login") }}</span>
          </router-link>
        </li>
        <li class="sideNavMenu_item_parent_title" v-if="this.CatalogTrainingVisible && $hasPermission('read_training')">
          <div class="submenu-trigger"><i class="uil-bell"></i><span class="sideNavMenu_item_title">{{
            this.$t("general.requests_my_demands") }}
            </span>
            <span class="nav-tag" v-if="this.$isSuperAdmin">{{
              userPurchaseCount + userRequestCount
            }}</span>
            <span class="nav-tag" v-else>{{ userRequestCount }}</span>
          </div>
          <ul>
            <li>
              <router-link :to="{ name: 'company.requests.user' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.user_requests")
                }}</span>
                <span class="nav-tag white">{{ userRequestCount }}</span>
              </router-link>
            </li>
            <li v-if="this.$isSuperAdmin">
              <router-link :to="{ name: 'company.requests.purchase' }">
                <span class="sideNavMenu_item_title">{{ $t('general.my_purchase_requests') }}
                </span>
                <span class="nav-tag white">{{ userPurchaseCount }}</span>
                <!-- <span class="nav-tag white">3</span> -->
              </router-link>
            </li>
          </ul>
        </li>
        <li class="sideNavMenu_item_parent_title" v-if="this.$isSuperAdmin">
          <div class="submenu-trigger">
            <i class="uil-building"></i><span class="sideNavMenu_item_title">{{ $t('general.institutions') }}</span>
          </div>
          <ul>
            <li v-if="this.$isSuperAdmin">
              <router-link :to="{ name: 'company.institutions.add' }">
                <span class="sideNavMenu_item_title">{{ $t('general.add_institution') }}</span>
              </router-link>
            </li>
            <li v-if="subCompany?.length > 1">
              <router-link :to="{ name: 'company.institutions.list' }">
                <span class="sideNavMenu_item_title">{{ $t('general.institution_list') }}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="sideNavMenu_item_parent_title" v-if="this.$isSuperAdmin">
          <div class="submenu-trigger">
            <i class="uil-store-alt"></i><span class="sideNavMenu_item_title">{{ $t('general.companies') }}</span>
          </div>
          <ul>
            <li>
              <router-link :to="{ name: 'company.companies.add' }">
                <span class="sideNavMenu_item_title">{{ $t('general.add_company') }}</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'company.companies.list' }">
                <span class="sideNavMenu_item_title">{{ $t('general.company_list') }}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="sideNavMenu_item_parent_title" v-if="$hasPermission('read_user')">
          <div class="submenu-trigger">
            <i class="uil-users-alt"></i><span class="sideNavMenu_item_title">
              {{ $t("users.users") }}</span>
          </div>
          <ul>
            <li v-if="$hasPermission('create_user')">
              <router-link :to="{ name: 'company.user.add' }">
                <span class="sideNavMenu_item_title">{{
                  $t("menu.company_dashboard.add_users")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_user')">
              <router-link :to="{ name: 'company.user.list' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.user_list")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_group')">
              <router-link :to="{ name: 'company.user.group' }">
                <span class="sideNavMenu_item_title">{{
                  $t("user_group.title")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_group')">
              <router-link :to="{ name: 'company.user.passive.list' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.inactive_users_groups")
                }}</span>
              </router-link>
            </li>
            <li v-if="isHierarchy">
              <router-link :to="{ name: 'company.user.hierarchy' }">
                <span class="sideNavMenu_item_title">
                  {{ $t('general.user_hierarchy_schema') }}
                </span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="sideNavMenu_item_parent_title" v-if="$hasPermission('read_instructor')">
          <div class="submenu-trigger">
            <i class="uil-graduation-hat"></i>
            <span class="sideNavMenu_item_title">{{
              $t("general.instructors")
            }}</span>
          </div>
          <ul>
            <li v-if="$hasPermission('create_instructor')">
              <router-link :to="{ name: 'company.instructors.add' }">
                <span class="sideNavMenu_item_title">{{
                  $t("general.add_instructor")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_instructor')">
              <router-link :to="{ name: 'company.instructors.list' }">
                <span class="sideNavMenu_item_title">{{
                  $t("general.instructor_list")
                }}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="sideNavMenu_item_parent_title" v-if="$hasPermission('read_content')">
          <div class="submenu-trigger">
            <i class="uil-book-open"></i>
            <span class="sideNavMenu_item_title">{{
              this.$t("general.contents")
            }}</span>
          </div>
          <ul>
            <li v-if="$hasPermission('create_content')">
              <router-link :to="{ name: 'company.content.add' }">
                <span class="sideNavMenu_item_title">
                  {{
                    $t("menu.company_dashboard.create_contact_material")
                  }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_content')">
              <router-link :to="{ name: 'company.contents.all' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.all_contents")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_content')">
              <router-link :to="{ name: 'company.contents.archive' }">
                <span class="sideNavMenu_item_title">
                İçerik Arşivi</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="sideNavMenu_item_parent_title" v-if="$hasPermission('read_hashtag')">
          <div class="submenu-trigger"><i class="uil-tag-alt"></i>
            <span class="sideNavMenu_item_title">
              {{ this.$t("general.tags") }}</span>
          </div>
          <ul>
            <li v-if="$hasPermission('create_hashtag')">
              <router-link :to="{ name: 'company.hashtags.add' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.add_tag")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_hashtag')">
              <router-link :to="{ name: 'company.hashtags.list' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.tag_list")
                }}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="sideNavMenu_item_parent_title" v-if="$hasPermission('read_program')">
          <div class="submenu-trigger">
            <i class="uil-file-plus-alt"></i>
            <span class="sideNavMenu_item_title">{{
              this.$t("general.programs")
            }}</span>
          </div>
          <ul>
            <li v-if="$hasPermission('create_program')">
              <router-link :to="{ name: 'company.program.add' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.add_program")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_program')">
              <router-link :to="{ name: 'company.programs.all' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.all_programs")
                }}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="sideNavMenu_item_parent_title" v-if="$hasPermission('read_assignment')">
          <div class="submenu-trigger"><i class="uil-location-arrow"></i>
            <span class="sideNavMenu_item_title">
              {{ $t("menu.company_dashboard.assignments") }}</span>
          </div>
          <ul>
            <li v-if="$hasPermission('create_assignment')">
              <router-link :to="{ name: 'company.assignments.add' }">
                <span class="sideNavMenu_item_title">
                  {{ $t("menu.company_dashboard.create_assignment") }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_assignment')">
              <router-link :to="{ name: 'company.assignments.list' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.all_assignments")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_assignment')">
              <router-link :to="{ name: 'company.assignments.list-passive' }">
                <span class="sideNavMenu_item_title"> {{ this.$t("general.passive_assignments") }}</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'company.assignments.auto' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.auto_assignments")
                }}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="sideNavMenu_item_parent_title"
          v-if="$hasPermission('read_competency') || $hasPermission('read_automaticcompetency')">
          <div class="submenu-trigger"><i class="icon-feather-star"></i>
            <span class="sideNavMenu_item_title">
              {{ $t('general.competencies') }} </span>
          </div>
          <ul>
            <li v-if="$hasPermission('read_competency')">
              <router-link :to="{ name: 'competencies.and.user.definitions' }">
                <span class="sideNavMenu_item_title">
                  {{ $t('general.competency_and_user_def') }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_automaticcompetency')">
              <router-link :to="{ name: 'automatic.competency.definitions' }">
                <span class="sideNavMenu_item_title"> {{ $t('general.automatic_competency_definitions') }} </span>
              </router-link>
            </li>

          </ul>
        </li>

        <li v-if="$hasPermission('read_competency')">
          <router-link class="development-evaluation-link" :to="{ name: 'company.development-evaluation.index' }">
            <i class="uil-chart-growth"></i>
            <span class="sideNavMenu_item_title">{{ $t('general.development_evaluation') }}</span>
          </router-link>
        </li>

        <li class="sideNavMenu_item_parent_title" v-if="$hasPermission('read_training')">
          <div class="submenu-trigger"><i class="uil-books"></i>
            <span class="sideNavMenu_item_title">{{
              this.$t("general.catalog_trainings")
            }}</span>
          </div>
          <ul>
            <li v-if="$hasPermission('create_training')">
              <router-link :to="{ name: 'company.content.catalog.add' }"><span class="sideNavMenu_item_title">
                  {{ $t("general.add_catalog_education") }}
                </span></router-link>
            </li>
            <li v-if="$hasPermission('show_training')">
              <router-link :to="{ name: 'company.education.catalog.list' }"><span class="sideNavMenu_item_title">
                  {{ this.$t("general.all_catalog_trainings") }}</span></router-link>
            </li>
            <li v-if="hasIyzicoIntegration">
              <router-link :to="{ name: 'company.education.catalog.purchased' }"><span class="sideNavMenu_item_title">
                  {{ this.$t("general.purchased_catalog_trainings") }}</span></router-link>
            </li>
          </ul>
        </li>
        <!-- <li><a href="dashboard.html"><i class="uil-bolt-alt"></i> <span class="sideNavMenu_item_title"> Düellolar</span></div> </li>
        </li> -->
        <li class="sideNavMenu_item_parent_title" v-if="$hasPermission('read_survey')">
          <div class="submenu-trigger"><i class="uil-notes"></i>
            <span class="sideNavMenu_item_title">{{
              this.$t("general.all_surveys")
            }}</span>
          </div>
          <ul>
            <li v-if="$hasPermission('create_survey')">
              <router-link :to="{ name: 'company.survey.add' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.add_survey")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('show_survey')">
              <router-link :to="{ name: 'company.surveys.list' }">
                <span class="sideNavMenu_item_title">
                  {{ this.$t("survey.surveys") }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('create_evaluationsurvey')">
              <router-link :to="{ name: 'company.evaluation-survey.add' }">
                <span class="sideNavMenu_item_title">
                  {{ $t("evaluation_survey.add") }}
                </span>
              </router-link>
            </li>
            <li v-if="$hasPermission('show_evaluationsurvey')">
              <router-link :to="{ name: 'company.evaluation-surveys.list' }">
                <span class="sideNavMenu_item_title">
                  {{ $t("menu.company_dashboard.evaluation_surveys") }}
                </span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="sideNavMenu_item_parent_title" v-if="$hasPermission('read_exam')">
          <div class="submenu-trigger">
            <i class="uil-pen"></i>
            <span class="sideNavMenu_item_title"> {{ $t("exam.exams") }}</span>
          </div>
          <ul>
            <li v-if="$hasPermission('show_exam')">
              <router-link :to="{ name: 'company.exams.list' }">
                <span class="sideNavMenu_item_title">{{
                  $t("exam.exams")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('create_exam')">
              <router-link :to="{ name: 'company.exam.add-demo' }">
                <span class="sideNavMenu_item_title">
                  {{ $t("exam.add") }}
                </span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="sideNavMenu_item_parent_title" v-if="$hasPermission('read_report')">
          <div class="submenu-trigger"><i class="uil-chart-pie"></i>
            <span class="sideNavMenu_item_title">{{
              this.$t("general.reports")
            }}</span>
          </div>
          <ul>
            <li v-if="this.$isSuperAdmin">
              <router-link :to="{ name: 'company.reports.statistics' }">
                <span class="sideNavMenu_item_title">{{ $t('general.report_statistics') }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_institutionreport')">
              <router-link :to="{ name: 'company.reports.institutions' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.organization_reports")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_companycontractreport')">
              <router-link :to="{ name: 'company.reports.licences' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.business_partner_license_reports")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_userreport')">
              <router-link :to="{ name: 'company.reports.users' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.user_reports")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_usereducationcumulativereport')">
              <router-link :to="{ name: 'company.reports.userCumulative' }">
                <span class="sideNavMenu_item_title">{{ this.$t('general.user_cumulative_reports') }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_certificatereport')">
              <router-link :to="{ name: 'company.reports.certificates' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.certification_reports")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_giftreport') && this.$isGiftVisible">
              <router-link :to="{ name: 'company.reports.gifts' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.gift_reports")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_usersurveyresultreport')">
              <router-link :to="{ name: 'company.reports.surveyReports' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.survey_reports")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_educationenddetailevaluationreport')">
              <router-link :to="{
                name: 'company.reports.educationEndGeneralEvaluationReport',
              }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.end_of_training_general_evaluation_report")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_userassignmentdetailreport')">
              <router-link :to="{
                name: 'company.reports.educationEndDetailEvaluationReport',
              }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.end_of_training_detailed_evaluation_report")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_userassignmentreport')">
              <router-link :to="{ name: 'company.reports.userAssignments' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.user_assignment _reports")
                }}</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{
                    name: 'company.reports.userAssignmentGeneralReport',
                  }">
                <span class="sideNavMenu_item_title">Kullanıcı Atama Genel Raporu</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_contentreport')">
              <router-link :to="{ name: 'company.reports.contents' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.content_reports")
                }}</span>
              </router-link>
            </li>

            <li v-if="$hasPermission('read_usercontentreport')">
              <router-link :to="{ name: 'company.reports.userContents' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.user_content_report")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_examreport')">
              <router-link :to="{ name: 'company.reports.exams' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.exam_general_report")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_examresultreport')">
              <router-link :to="{ name: 'company.reports.examResults' }">
                <span class="sideNavMenu_item_title">{{
                  this.$t("general.exam_detailed_report")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_usertrainingreport')">
              <router-link :to="{ name: 'company.reports.selfRegistiration' }">
                <span class="sideNavMenu_item_title">
                  {{ $t("general.catalog_training_reports") }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_linkedinlearningreport')">
              <router-link :to="{ name: 'company.reports.linkedin-learning' }">
                <span class="sideNavMenu_item_title">
                  {{ $t("report.linkedin.report") }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_udemyreport')">
              <router-link :to="{ name: 'company.reports.udemy-reports' }">
                <span class="sideNavMenu_item_title">
                  {{ $t("report.udemy.report") }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_harvardreport')">
              <router-link :to="{ name: 'company.reports.harvard-business-reports' }">
                <span class="sideNavMenu_item_title">
                  {{ $t("report.harvard.report") }}
                </span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_externalreport')">
              <router-link :to="{ name: 'company.reports.external-source-reports' }">
                <span class="sideNavMenu_item_title">{{
                  $t("menu.external_source_reports")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_prepostreport')">
              <router-link :to="{ name: 'company.reports.pre-post-reports' }">
                <span class="sideNavMenu_item_title">{{
                  $t("menu.pre-post-reports")
                }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_report')">
              <router-link :to="{ name: 'company.reports.metabase-report' }">
                <span class="sideNavMenu_item_title">{{ $t("report.analytics") }}</span>
              </router-link>
            </li>
            <li v-if="$hasPermission('read_report')">
              <router-link :to="{ name: 'company.reports.userLoginReport' }">
                <span class="sideNavMenu_item_title">{{ $t("report.user_login_report") }}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <ul :data-submenu-title="this.$t('general.management_tools')" id="general_sub_menu_list">
          <li v-if="$hasPermission('read_companysetting')">
            <router-link :to="{ name: 'company.setting' }">
              <i class="uil-cog"></i>
              <span class="sideNavMenu_item_title">
                {{ $t("menu.company_dashboard.setting") }}</span>
            </router-link>
          </li>
          <li v-if="$hasPermission('read_branch') || $hasPermission('read_department')
            || $hasPermission('read_region') || $hasPermission('read_title') || $hasPermission('read_position')">
            <router-link :to="{ name: 'company.data' }">
              <i class="uil-database-alt"></i>
              <span class="sideNavMenu_item_title">
                {{ $t("menu.company_dashboard.data") }}</span>
            </router-link>
          </li>
          <li v-if="hasIyzicoIntegration && $hasPermission('read_ordermanagement')">
            <router-link :to="{ name: 'company.management.order' }">
              <i class="uil-shopping-cart-alt"></i>
              <span class="sideNavMenu_item_title"> {{ $t('general.order_management') }}</span>
            </router-link>
          </li>
          <li v-if="hasIyzicoIntegration && $hasPermission('read_paymenttransaction')">
            <router-link :to="{ name: 'company.payment_history.content' }">
              <i class="uil-shopping-cart-alt"></i>
              <span class="sideNavMenu_item_title"> {{ $t('general.payment_transactions') }}</span>
            </router-link>
          </li>
          <li v-if="$hasPermission('read_point')">
            <router-link :to="{ name: 'company.point.list' }">
              <i class="uil-game-structure"></i>
              <span class="sideNavMenu_item_title">
                {{ $t("point.gamification") }}
              </span>
            </router-link>
          </li>
          <li class="sideNavMenu_item_parent_title" v-if="$hasPermission('read_permission')">
            <div class="submenu-trigger"><i class="uil-key-skeleton"></i>
              <span class="sideNavMenu_item_title">{{ $t('general.authorization') }}</span>
            </div>
            <ul>
              <li v-if="$hasPermission('read_role')">
                <router-link :to="{ name: 'company.authorization.roles' }">
                  <span class="sideNavMenu_item_title">{{ $t('general.roles') }}</span>
                </router-link>
              </li>
              <li v-if="this.$isSuperAdmin">
                <router-link :to="{ name: 'company.authorization.permission' }">
                  <span class="sideNavMenu_item_title">{{ $t('general.permissions') }}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="sideNavMenu_item_parent_title"
            v-if="$hasPermission('read_sharesmanagement') || $hasPermission('read_missionmanagement') || $hasPermission('read_competency')">
            <div class="submenu-trigger"><i class="uil-check-square"></i>
              <span class="sideNavMenu_item_title"> {{ $t('general.my_approvements') }}</span>
              <span v-if="totalApprovalCount > 0" class="nav-tag">{{ totalApprovalCount }}</span>
            </div>
            <ul>
              <li v-if="$hasPermission('read_sharesmanagement')">
                <router-link :to="{ name: 'company.management.share' }">
                  <span class="sideNavMenu_item_title">
                    {{ $t("menu.company_dashboard.manage_posts") }}</span>
                  <span v-if="comments?.total > 0" class="nav-tag">{{
                    comments.total
                  }}</span>
                </router-link>
              </li>
              <li v-if="$hasPermission('read_missionmanagement')">
                <router-link :to="{ name: 'company.management.content' }">
                  <span class="sideNavMenu_item_title"> {{ $t('general.my_content_approvals') }}</span>
                  <span v-if="missionContentCount > 0" class="nav-tag">{{
                    missionContentCount
                  }}</span>
                </router-link>
              </li>
              <li v-if="$hasPermission('read_competency')">
                <router-link :to="{ name: 'company.management.competency' }">
                  <span class="sideNavMenu_item_title">{{ $t('general.my_competency_approvals') }} </span>
                  <span v-if="competencyContentCount > 0" class="nav-tag">{{ competencyContentCount }}</span>
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'company.management.collection' }">
                  <span class="sideNavMenu_item_title"> {{ $t('general.collection_approvements') }}</span>
                  <span v-if="collectionContentCount > 0" class="nav-tag">{{ collectionContentCount }}</span>
                </router-link>
              </li>
            </ul>
          </li>

          <li v-if="$hasPermission('show_certificate')">
            <router-link :to="{ name: 'company.certificate.list' }">
              <i class="uil-medal"></i>
              <span class="sideNavMenu_item_title">{{
                $t("certificate.management")
              }}</span>
            </router-link>
          </li>
          <li v-if="$hasPermission('show_certificatetemplate')">
            <router-link :to="{ name: 'company.certificate_template.list' }">
              <i class="uil-object-group"></i>
              <span class="sideNavMenu_item_title">{{
                $t("certificate_template.management")
              }}</span>
            </router-link>
          </li>

          <li v-if="$hasPermission('read_mail')">
            <router-link :to="{ name: 'company.mail.templates2' }">
              <i class="uil-mailbox"></i>
              <span class="sideNavMenu_item_title">
                {{ this.$t("general.manage_email_templates") }}</span>
            </router-link>
          </li>

          <li v-if="$hasPermission('show_integration')">
            <router-link :to="{ name: 'company.integrations.list' }"><i class="uil-puzzle-piece"></i>
              <span class="sideNavMenu_item_title">
                <!-- {{ $t("menu.company_dashboard.announcement") }} -->
                {{ this.$t("api_integration.api_integration") }}
              </span>
            </router-link>
          </li>
          <li v-if="$hasPermission('read_additionalapplication')">
            <router-link :to="{ name: 'company.solution-partners.list' }"><i class="uil-heart"></i>
              <span class="sideNavMenu_item_title">
                <!-- {{ $t("menu.company_dashboard.announcement") }} -->
                {{ $t('general.solution_partners_apps') }}
              </span>
            </router-link>
          </li>
          <li v-if="$hasPermission('read_leaderboardrule')">
            <router-link :to="{ name: 'company.leaders.table.management' }"><i class="uil-trophy"></i>
              <span class="sideNavMenu_item_title">
                {{ $t('general.leader_table_management') }}
              </span>
            </router-link>
          </li>

          <li class="sideNavMenu_item_parent_title" v-if="this.$isGiftVisible && $hasPermission('read_gift')">
            <div class="submenu-trigger"><i class="uil-gift"></i>
              <span class="sideNavMenu_item_title">{{
                this.$t("general.manage_gifts")
              }}</span>
            </div>
            <ul>
              <li v-if="$hasPermission('read_gift')">
                <router-link :to="{ name: 'company.gift.requests' }">
                  <span class="sideNavMenu_item_title">{{
                    this.$t("general.gift_requests")
                  }}</span>
                </router-link>
              </li>
              <li v-if="$hasPermission('create_gift')">
                <router-link :to="{ name: 'company.gift.add' }">
                  <span class="sideNavMenu_item_title">{{
                    this.$t("general.add_gift")
                  }}</span>
                </router-link>
              </li>
              <li v-if="$hasPermission('show_gift')">
                <router-link :to="{ name: 'company.gift.list' }">
                  <span class="sideNavMenu_item_title">{{
                    this.$t("general.gift_list")
                  }}</span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="sideNavMenu_item_parent_title" v-if="$hasPermission('read_faq')">
            <div class="submenu-trigger"><i class="uil-question-circle"></i>
              <span class="sideNavMenu_item_title">
                {{ this.$t("general.faq") }}</span>
            </div>
            <ul>
              <li v-if="$hasPermission('read_faq')">
                <router-link :to="{ name: 'company.faq.list' }">
                  <span class="sideNavMenu_item_title">{{ $t('general.faq_list') }}</span>
                </router-link>
              </li>
              <li v-if="$hasPermission('create_faq')">
                <router-link :to="{ name: 'company.faq.add' }">
                  <span class="sideNavMenu_item_title">{{
                    this.$t("faq.add")
                  }}</span>
                </router-link>
              </li>
              <li v-if="$hasPermission('read_faq')">
                <router-link :to="{ name: 'company.faq_categories.list' }">
                  <span class="sideNavMenu_item_title">{{
                    $t("general.category_list")
                  }}</span>
                </router-link>
              </li>
              <li v-if="$hasPermission('create_faq')">
                <router-link :to="{ name: 'company.faq_categories.add' }">
                  <span class="sideNavMenu_item_title">{{
                    $t("general.add_category")
                  }}</span>
                </router-link>
              </li>
            </ul>
          </li>

          <li v-if="$hasPermission('show_advertisement')">
            <router-link :to="{ name: 'company.advertisement.list' }"><i class="icon-line-awesome-buysellads"></i>
              <span class="sideNavMenu_item_title">
                {{ $t("menu.company_dashboard.advertisement") }}</span>
            </router-link>
          </li>
          <li v-if="$hasPermission('read_notice')">
            <router-link :to="{ name: 'company.announcement.list' }"><i class="uil-megaphone"></i>
              <span class="sideNavMenu_item_title">
                {{ $t("menu.company_dashboard.announcement") }}</span>
            </router-link>
          </li>
          <li v-if="$hasPermission('read_widgetmanagement')">
            <router-link :to="{ name: 'company.menu_modules.list' }"><i class="fab fa-mendeley"></i>
              <span class="sideNavMenu_item_title">{{
                this.$t("general.manage_menu_modules")
              }}</span>
            </router-link>
          </li>
        </ul>
      </ul>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import store from "@/core/services/index";
import EventBus from "@/view/components/event-bus";
import { integrationMixin } from "@/core/mixin/integration.mixin";

import company_module, {
  SELF_URL as COMPANY_SELF_URL,
  GET_SELF as COMPANY_GET_SELF,
  SELF as COMPANY_SELF,
  MODULE_NAME as COMPANY_MODULE_NAME,
} from "@/core/services/store/company.module";

import trainingModule, {
  MODULE_NAME as TRAINING_MODULE_NAME,
  GET_REQUEST_COUNT as GET_TRAINING_USER_REQUEST_COUNT,
  REQUEST_COUNT as TRAINING_USER_REQUEST_COUNT,
} from "@/core/services/store/training.module";

import purchaseModule, {
  MODULE_NAME as PURCHASE_MODULE_NAME,
  GET_REQUEST_COUNT as GET_PURCHASE_USER_REQUEST_COUNT,
  REQUEST_COUNT as PURCHASE_USER_REQUEST_COUNT,
} from "@/core/services/store/training_purchase.module";

import comment_module, {
  MODULE_NAME,
} from "@/core/services/store/comment.module";
import { subCompany, parentCompany } from "@/core/services/store.js";
import axios from "axios";
import SecureLS from "secure-ls";
import { syncHierarchyFromService, isHierarchy } from "@/core/services/store.js";
const ls = new SecureLS({ encodingType: "aes", isCompression: true });
const _COMPANY_MODULE_NAME = COMPANY_MODULE_NAME;
const _TRAINING_MODULE_NAME = TRAINING_MODULE_NAME;
const _PURCHASE_MODULE_NAME = PURCHASE_MODULE_NAME;

export default {
  name: "SideNav",
  mixins: [integrationMixin],
  data() {
    return {
      subCompany: subCompany,
      userShareCount: 0,
      searchForMenu: "",
      trainingUserRequestUrl: "api/training-requests?count=true",
      purchaseUserRequestUrl: "api/purchase-request-count",
      missionContentCount: 0,
      competencyContentCount: 0,
      collectionContentCount: 0,
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(_COMPANY_MODULE_NAME, company_module);
    registerStoreModule(_TRAINING_MODULE_NAME, trainingModule);
    registerStoreModule(_PURCHASE_MODULE_NAME, purchaseModule);
    registerStoreModule(MODULE_NAME, comment_module);
  },
  computed: {
    isHierarchy() {
      return isHierarchy.value;
    },
    company: {
      get() {
        return store.getters[COMPANY_MODULE_NAME + "/" + COMPANY_SELF];
      },
      set(value) { },
    },
    userRequestCount() {
      return store.getters[
        _TRAINING_MODULE_NAME + "/" + TRAINING_USER_REQUEST_COUNT
      ];
    },
    userPurchaseCount() {
      return store.getters[
        _PURCHASE_MODULE_NAME + "/" + PURCHASE_USER_REQUEST_COUNT
      ];
    },
    logo() {
      if (this.company == null) return "";
      return this.company.logo_link;
    },
    user_header: {
      get() {
        return JSON.parse(this.secureLocalStorage("user"));
      },
      set() { },
    },
    comments() {
      return this.$store.getters["COMMENT/ITEMS"];
    },
    totalApprovalCount() {
      const commentsTotal = this.comments?.total || 0;
      const missionCount = this.missionContentCount || 0;
      const competencyCount = this.competencyContentCount || 0;
      const collectionCount = this.collectionContentCount || 0;
      return commentsTotal + missionCount + competencyCount + collectionCount;
    },
  },
  methods: {
    superAdmin() {
      if (this.user_header === null || !("roles" in this.user_header)) {
        return false;
      }
      if (this.user_header.roles.length > 2) {
        return true;
      } else {
        return false;
      }
    },
    getCompanyItem() {
      this.$store
        .dispatch(COMPANY_MODULE_NAME + "/" + COMPANY_GET_SELF, {
          url: COMPANY_SELF_URL,
        })
        .then((response) => {
          syncHierarchyFromService(response);
          let flag = 1;
          subCompany.value = response.children;

          subCompany.value?.unshift({
            name: JSON.parse(ls.get("parentCompany"))?.company_name,
            id: JSON.parse(ls.get("parentCompany"))?.company_id,
          });

          const root = document.querySelector(":root");

          const settings = response?.settings?.find((x) => x.key === "theme_settings")?.value;
          const defaultColors = {
            iconColor: "#93949c",
            infoColor: "#00b8d9",
            backgroundColor: "#666CFF",
            primaryColor: '#3F51B5',
            secondaryColor: '#eff2f7',
            dangerColor: '#EC5252',
            successColor: '#36b37e',
            warningColor: '#ffab00'
          };

          ['iconColor', 'backgroundColor'].forEach((key) => {
            root.style.setProperty(`--${key}`, settings?.[key] || defaultColors[key]);
          });

          Object.entries(defaultColors).forEach(([key, value]) => {
            if (key !== 'iconColor' && key !== 'backgroundColor') {
              root.style.setProperty(`--${key}`, value);
            }
          });

        });
    },
    getUserTrainingRequestCount() {
      if (!this.CatalogTrainingVisible) {
        return false;
      }
      this.$store.dispatch(
        _TRAINING_MODULE_NAME + "/" + GET_TRAINING_USER_REQUEST_COUNT,
        {
          url: this.trainingUserRequestUrl,
        }
      );
    },
    getUserPurchaseRequestCount() {
      this.$store.dispatch(
        _PURCHASE_MODULE_NAME + "/" + GET_PURCHASE_USER_REQUEST_COUNT,
        {
          url: this.purchaseUserRequestUrl,
        }
      );
    },
    async getUserShareCount() {
      const filters = {
        page: 1,
        sort: "created_at",
        order: "desc",
        status_id: 1,
        with_user: true,
        per_page: 3,
        search: null,
      };

      await this.$store.dispatch("COMMENT/GET_ITEMS", {
        url: "api/shares-management",
        filters,
      });
    },
    async getMissionManagementContentCount() {
      const { data } = await axios.get(`api/mission-management/`, {
        params: {
          count: true,
        },
        headers: this.apiHeaders,
      });
      this.missionContentCount = data;
    },
    async fetchCompetenciesApprovalCount() {
      const { data } = await axios.get(`api/competencies/approval-management`, {
        params: {
          count: true
        }
      })
      this.competencyContentCount = data
    },
    async fetchCollectionApprovalCount() {
      const { data } = await axios.get(`api/collection-verify-management`, {
        params: {
          count: true
        }
      })
      this.collectionContentCount = data
    },
    setActiveMenuItem() {
      const menuItems = document.querySelectorAll(".sideNavMenu li a");

      const currentPath = this.$route.path;
      const developmentEvaluationPath = "/admin/development-evaluation";

      menuItems.forEach((item) => {
        const itemPath = item.getAttribute("href")?.replace("#", "");
        const isDevelopmentEvaluationRoute =
          itemPath === developmentEvaluationPath &&
          currentPath.startsWith(developmentEvaluationPath);

        if (itemPath === currentPath || isDevelopmentEvaluationRoute) {
          const parentLi = item.closest("li");

          if (
            parentLi.parentElement.tagName === "UL" &&
            parentLi.parentElement.parentElement.classList.contains(
              "sideNavMenu_item_parent_title"
            )
          ) {
            parentLi.parentElement.parentElement.classList.add(
              "active-submenu"
            );
          }

          parentLi.classList.add("active-submenu");
        }
      });
    },
  },
  mounted() {
    this.getCompanyItem();
    this.getUserTrainingRequestCount();
    this.getUserPurchaseRequestCount();
    if (this.$hasPermission("read_sharesmanagement")) this.getUserShareCount();
    if (this.$hasPermission("read_missionmanagement"))

      this.getMissionManagementContentCount();
    this.fetchCompetenciesApprovalCount()
    this.fetchCollectionApprovalCount()
    this.loadIntegrations();

    EventBus.$on("missionContentCount", (count) => {
      this.missionContentCount = count
    });

    EventBus.$on("competencyContentCount", (count) => {
      this.competencyContentCount = count
    });

    EventBus.$on("collectionContentCount", (count) => {
      this.collectionContentCount = count
    });

    this.$nextTick(() => {
      // Native addEventListener — jQuery/main.js çakışması olmaz
      var menuEl = document.getElementById("admin_sideNavMenu");
      if (menuEl) {
        this._menuClickHandler = function (e) {
          // Dropdown trigger tıklaması
          var trigger = e.target.closest(".submenu-trigger");
          if (trigger) {
            var li = trigger.closest("li");
            if (!li) return;
            e.preventDefault();
            e.stopPropagation();
            var allItems = menuEl.querySelectorAll("li");
            if (li.classList.contains("active-submenu")) {
              allItems.forEach(function (el) { el.classList.remove("active-submenu"); });
            } else {
              allItems.forEach(function (el) { el.classList.remove("active-submenu"); });
              li.classList.add("active-submenu");
            }
            return;
          }

          // Alt link tıklaması — anında bg değiştir
          var link = e.target.closest("a");
          if (link) {
            var clickedLi = link.closest("li");
            if (clickedLi) {
              menuEl.querySelectorAll("li.active-submenu:not(.sideNavMenu_item_parent_title)").forEach(function (el) {
                el.classList.remove("active-submenu");
              });
              clickedLi.classList.add("active-submenu");
              // Parent dropdown'u da açık tut
              var parentLi = clickedLi.closest(".sideNavMenu_item_parent_title");
              if (parentLi) {
                parentLi.classList.add("active-submenu");
              }
            }
          }
        };
        menuEl.addEventListener("click", this._menuClickHandler);
      }
      this.setActiveMenuItem();
    });
  },
  watch: {
    searchForMenu(val) {
      val = this.turkishToLower(val.trim().toString());
      let general_sub_menu = document.getElementById("general_sub_menu_list");
      var nav_spans = document
        .getElementById("admin_sideNavMenu")
        .querySelectorAll(".sideNavMenu_item_title");
      nav_spans.forEach((span) => {
        let closest_li = span.closest("li");
        let closest_li_classlist = closest_li.classList;
        if (
          this.turkishToLower(span.innerText.trim().toString()).includes(val) ||
          val == ""
        ) {
          closest_li_classlist.remove("hidden");
        } else {
          if (closest_li_classlist.contains("sideNavMenu_item_parent_title")) {
            if (
              closest_li.querySelectorAll("li.hidden").length ==
              closest_li.querySelectorAll("li").length
            ) {
              closest_li_classlist.add("hidden");
            }
          } else {
            closest_li_classlist.add("hidden");
          }
        }
      });
      if (
        general_sub_menu != null &&
        general_sub_menu.querySelectorAll("li").length ==
        general_sub_menu.querySelectorAll("li.hidden").length
      ) {
        general_sub_menu.classList.add("hidden");
      } else {
        general_sub_menu.classList.remove("hidden");
      }
    },
    $route(to, from) {
      var menuEl = document.getElementById("admin_sideNavMenu");
      if (menuEl) {
        menuEl.querySelectorAll("ul li a").forEach(function (link) {
          var url = (link.getAttribute("href") || "").replace("#", "");
          if (url !== to.path) {
            link.parentElement.classList.remove("active-submenu");
          }
        });
      }
      this.$nextTick(() => {
        this.setActiveMenuItem();
      });
    },
  },
  beforeDestroy() {
    var menuEl = document.getElementById("admin_sideNavMenu");
    if (menuEl && this._menuClickHandler) {
      menuEl.removeEventListener("click", this._menuClickHandler);
    }
    EventBus.$off("missionContentCount");
    EventBus.$off("competencyContentCount");
    EventBus.$off("collectionContentCount");
  }
};
</script>
<style scoped>
.hidden {
  display: none !important;
}

/* Sidebar kapatma butonu — global kurallar style.css:2393'te,
   @media (max-width: 1220px) altinda. */
@media (max-width: 1220px) {
  /* Buton .page-menu'nun ucuncu cocugu ve z-index'i yoktu. Kendisinden
     SONRA gelen kardesler (ozellikle .page-menu-inner / simplebar) ayni
     yigin baglaminda daha ustte boyandigi icin butonun uzerine biniyor ve
     dokunma bazen butona hic ulasmiyordu. */
  .btn-menu-close {
    z-index: 5;
  }

  /* MOBILE_UI_GUIDELINES: ikon buton min 44x44 (onceden 40x40) */
  .mobile-active .btn-menu-close {
    width: 44px;
    height: 44px;
  }
}
</style>
<style>
.admin-panel>.page-menu>.page-menu-inner>.simplebar-wrapper>.simplebar-mask>.simplebar-offset>.simplebar-content {
  overflow-y: auto !important;
}

/* Daraltılmış sidenav (menu-large) */
@media (min-width: 1220px) {

  .page-menu.menu-large .sideNavMenu,
  .page-menu.menu-large .sideNavMenu ul,
  .page-menu.menu-large .sideNavMenu_item_parent_title>ul {
    transition: none !important;
  }

  .page-menu.menu-large .sideNavMenu_item_parent_title,
  .page-menu.menu-large .sideNavMenu_item_parent_title.active-submenu {
    display: block !important;
  }

  .page-menu.menu-large .submenu-trigger,
  .page-menu.menu-large #admin_sideNavMenu>li>a,
  .page-menu.menu-large .sideNavMenu>li>a {
    display: flex !important;
    align-items: center;
    box-sizing: border-box;
    min-height: 52px;
    line-height: 1.25;
  }

  .page-menu.menu-large .sideNavMenu_item_parent_title ul li a {
    display: flex !important;
    align-items: center;
    box-sizing: border-box;
    min-height: 0 !important;
    line-height: 1.35 !important;
  }

  .page-menu.menu-large:not(:hover) .sideNavMenu_item_title {
    position: absolute !important;
    width: 0 !important;
    height: 0 !important;
    overflow: hidden !important;
    opacity: 0 !important;
    visibility: hidden !important;
    padding: 0 !important;
    margin: 0 !important;
    white-space: nowrap !important;
  }

  .page-menu.menu-large:not(:hover) .submenu-trigger::after {
    opacity: 0 !important;
    visibility: hidden !important;
  }

  .page-menu.menu-large:not(:hover) .submenu-trigger,
  .page-menu.menu-large:not(:hover) #admin_sideNavMenu>li>a,
  .page-menu.menu-large:not(:hover) .sideNavMenu>li>a {
    justify-content: center;
    padding: 14px 0 !important;
  }

  .page-menu.menu-large:not(:hover) .submenu-trigger i,
  .page-menu.menu-large:not(:hover) #admin_sideNavMenu>li>a>i,
  .page-menu.menu-large:not(:hover) .sideNavMenu>li>a>i {
    margin-right: 0 !important;
  }

  .page-menu.menu-large:not(:hover) .sideNavMenu_item_parent_title>ul {
    display: none !important;
    max-height: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
    pointer-events: none !important;
    padding: 0 !important;
    margin: 0 !important;
    line-height: 0 !important;
  }

  .page-menu.menu-large:hover #admin_sideNavMenu,
  .page-menu.menu-large:hover .sideNavMenu {
    margin: 0 !important;
    padding-top: 0 !important;
  }

  .page-menu.menu-large:hover .sideNavMenu_item_title {
    position: static !important;
    width: auto !important;
    height: auto !important;
    opacity: 1 !important;
    visibility: visible !important;
    display: block !important;
    flex: 1 1 auto;
    min-width: 0;
    max-width: 100%;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    padding-left: 0 !important;
  }

  .page-menu.menu-large:hover .submenu-trigger::after {
    opacity: 1 !important;
    visibility: visible !important;
  }

  .page-menu.menu-large:hover .submenu-trigger,
  .page-menu.menu-large:hover #admin_sideNavMenu>li>a,
  .page-menu.menu-large:hover .sideNavMenu>li>a {
    justify-content: flex-start;
    padding: 14px 25px !important;
    overflow: hidden;
  }

  .page-menu.menu-large:hover .submenu-trigger i,
  .page-menu.menu-large:hover #admin_sideNavMenu>li>a>i,
  .page-menu.menu-large:hover .sideNavMenu>li>a>i {
    flex-shrink: 0;
    margin-right: 12px !important;
  }

  .page-menu.menu-large:hover .sideNavMenu_item_parent_title:not(.active-submenu)>ul {
    display: none !important;
    max-height: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
    pointer-events: none !important;
    padding: 0 !important;
    margin: 0 !important;
    line-height: 0 !important;
  }

  .page-menu.menu-large:hover .sideNavMenu_item_parent_title.active-submenu>ul {
    display: block !important;
    max-height: none !important;
    opacity: 1 !important;
    visibility: visible !important;
    pointer-events: all !important;
    line-height: 1.35 !important;
    padding: 0 0 4px 0 !important;
    margin: 0 !important;
  }

  .page-menu.menu-large:hover #admin_sideNavMenu ul li ul li a,
  .page-menu.menu-large:hover .sideNavMenu .sideNavMenu_item_parent_title ul li a {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-start !important;
    min-height: 0 !important;
    padding: 4px 16px 4px 0 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
  }

  .page-menu.menu-large:hover #admin_sideNavMenu ul li ul li {
    line-height: 1.35 !important;
    padding-left: 48px !important;
    margin: 0 !important;
  }

  .page-menu.menu-large:hover .sideNavMenu_item_parent_title ul li a .sideNavMenu_item_title {
    flex: 1 1 auto;
    min-width: 0;
  }

  .page-menu.menu-large:not(:hover) #general_sub_menu_list::before {
    display: none !important;
    content: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .page-menu.menu-large:hover #general_sub_menu_list {
    margin: 0 !important;
    padding-top: 0 !important;
  }

  .page-menu.menu-large:hover #general_sub_menu_list::before {
    display: block !important;
    margin-top: 0 !important;
    padding: 12px 25px 8px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .page-menu.menu-large .sideNavMenu li {
    transition: none !important;
  }

  .page-menu.menu-large:hover .sideNavMenu_item_parent_title ul li {
    display: block !important;
  }
}

.page-menu ul li.sideNavMenu_item_parent_title ul li.active-submenu {
  background-color: rgba(102, 103, 107, 0.08) !important;
  /* Daha koyu bir ton */
}

.page-menu ul li.sideNavMenu_item_parent_title ul li.active-submenu:hover {
  background-color: rgba(102, 103, 107, 0.1) !important;
}

.page-menu ul li.sideNavMenu_item_parent_title ul li.active-submenu a {
  font-weight: 500;
}

.sideNavMenu_item_parent_title ul {
  width: 100%;
}

/* submenu-trigger: <a> yerine <div> — aynı görünüm */
.page-menu ul li .submenu-trigger {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px 25px;
  color: inherit;
  user-select: none;
  position: relative;
}

.page-menu ul li .submenu-trigger i {
  margin-right: 12px;
  font-size: 22px;
  width: 22px;
  text-align: center;
}

.page-menu ul li .development-evaluation-link {
  align-items: center;
  box-sizing: border-box;
  color: inherit !important;
  display: flex;
  min-height: 45px;
  padding: 10px 25px;
}

.page-menu ul li .development-evaluation-link i {
  margin-right: 12px;
  top: 0;
  width: 22px;
}

.page-menu ul li .development-evaluation-link::after {
  display: none !important;
  content: none !important;
}

/* Açılır menü ok ikonu */
.page-menu ul li .submenu-trigger::after {
  font-family: "Feather-Icons";
  content: "\e92e";
  font-size: 16px;
  color: #a8a8a8;
  position: absolute;
  right: 35px;
  top: 15px;
  transition: 0.3s;
}

.page-menu ul li.active-submenu .submenu-trigger::after {
  content: "\e931";
  color: #66676b;
}
</style>
